<template>
  <div class="container container-global">
    <h2>SIU au Levonorgestrel</h2>
    <div class="content">
      <p>
        Support en plastique contenant du sulfate de Baryum et différents
        dosages de Levonorgestrel, 9µ/24h pour le KYLEENA et 20µg/24h pour le
        MIRENA
      </p>
      <br />
      <span>Mode d’action </span>
      <ul>
        <li>
          épaississement de la glaire cervicale et effet anti prolifératif sur
          l’endomètre
        </li>
      </ul>
      <br />
      <span>Contre-indications:</span>
      <br />
      <br />
      <p>
        Grossesse, grossesse molaire,
        <br />
        infections en cours, maladie inflammatoire pelvienne en cours,
        <br />
        cancer du sein, cancer de l’endomètre,
        <br />
        malformations utérine et fibromes déformant la cavité,
        <br />
        affection hépatique aiguë ou tumeur hépatique,
        <br />
        post partum immédiat (4 semaines),
        <br />
        Accident thromboembolique évolutif
        <br />
        Tabagisme après 35 ans
      </p>
      <br />
      <span>Effets indésirables : </span>
      <ul>
        <li>
          profils de saignements possibles (30% règles régulières, 30%
          aménorrhée, 30% spotting) à évaluer seulement 6 mois après la pose
        </li>
        <li>Aggravation de l’acné et de la pilosité</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .content {
    margin-top: 15px;
    p {
      color: $text-color-aigm;
    }
    span {
      color: $dark-pink;
      text-decoration: underline;
    }
    ul {
      margin: 15px auto 15px auto;
      width: 90%;
      li {
        margin-top: 10px;
        color: $text-color-aigm;
      }
    }
  }
}
</style>
